<app-billing-information-active></app-billing-information-active>
<app-billing-edit-license (licenceChanged)="licenceChanged.emit()"></app-billing-edit-license>
<app-billing-resign-license></app-billing-resign-license>
<app-billing-history></app-billing-history>
